module.exports = __webpack_public_path__ + "static/media/Card_Chewable.88b3418b.svg";